<div class="page-content" [hidden]="timerService.isForwarding">

      <div><button class="btn-back" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>
 
      <h1 class="page-title" translate>{{'birth_certificate.page_title'}}</h1>
 
      <!-- Child Deceased -->
      <div [hidden]="!(data.aboutChild.isChildDeceased == 'Y')">
           <div translate="birth_certificate.childDeceased.text1"></div>
           <div translate="birth_certificate.childDeceased.text2" class="padding-top-1em"></div>
           <div class="padding-top-2em" id="childDeceased">
                <h2 translate>{{'birth_certificate.certified_copy.header'}}</h2>
                <h3 translate>{{'birth_certificate.certified_copy.amount'}}</h3>
                <div>
                     <ul>
                          <li translate="birth_certificate.certified_copy.text1"></li>
                     </ul>
                </div>
                <ng-checkbox [(ng-model)]="orderOfBC.hasCertifiedCopyOfBR" (change)="addToOrderAmount('CBC')" id="childDeceasedBCcheckbox">
                     <div [hidden]="orderOfBC.hasCertifiedCopyOfBR === 'Y'" translate>
                          {{'birth_certificate.certified_copy.add_to_order'}}
                     </div>
                     <div [hidden]="!(orderOfBC.hasCertifiedCopyOfBR === 'Y')">
                          <strong translate>{{'birth_certificate.certified_copy.added_to_order'}}</strong>
                     </div>
                </ng-checkbox>
           </div>
      </div>
 
      <div [hidden]="(data.aboutChild.isChildDeceased == 'Y')"> 
           <div translate="birth_certificate.text1"></div>
           <div class="padding-top-1em">
                <span translate="birth_certificate.faq.text1"></span>
                <a-link link-url="birth_certificate.faq.faq_link.url" alt-text="birth_certificate.faq.link.alt_text" 
                     label='birth_certificate.faq.link.label'  (click)=onFaqClick($event)></a-link>
                <span translate="birth_certificate.faq.text3"></span>
           </div>
           <div translate="birth_certificate.text4" class="padding-top-1em"></div>
 
           <div class="padding-top-1em">
                <accordion label="birth_certificate.accordion.header" outer-class="bottom-margin">
                     <div translate='birth_certificate.accordion.text1'></div>
                     <div translate='birth_certificate.accordion.text2' class="padding-bottom-1em" ></div>
                     <div translate='birth_certificate.accordion.text3' class="padding-bottom-1em" ></div> 
                </accordion>
           </div>
 
           <!--Birth Certificate with Parental Information-->
           <div id="birthCertWithParentInfo" class="padding-top-2em">
                <h2 translate>{{'birth_certificate.parental.header'}}</h2>
                <h3 translate>{{'birth_certificate.parental.amount'}}</h3>
 
                <div style="display: inline-flex;">
                     <div>
                          <div translate class="sr-only">{{'birth_certificate.parental.thumbnail.aoda_text'}}</div>
                          <div tabindex="0" (keypress)="keyPressBox1($event)">
                               <div [hidden]="lang == 'fr'">
                                    <img src="refresh/assets/images/bc_parental_en.jpg" width="95" height="120" 
                                         (click)="onBox1Open();" id="myCanvas_en"
                                         class="cursor" 
                                         alt-text='birth_certificate.parental.thumbnail.alt_text'>
                               </div>
                               <div [hidden]="lang == 'en'">
                                    <img src="refresh/assets/images/bc_parental_fr.jpg" width="95" height="120" 
                                         (click)="onBox1Open();" id="myCanvas_fr"
                                         class="cursor" 
                                         alt-text='birth_certificate.parental.thumbnail.alt_text'>
                               </div>
                               <light-box input-class="white-box"  #bcParentalLightBox 
                                          outer-class="bc_sample" outer-style="margin-top:2em">
                                    <header-x (close)="onBox1Close()"></header-x>
                                    <div>
                                         <span translate class="sr-only">{{ 'birth_certificate.parental.main_image_aoda_text' }}</span>
                                         
                                         <div (click)="onBox1Close()">
                                              <canvas #parentalCanvas 
                                                      style="cursor:pointer;" role="img">
                                                   Your browser does not support the HTML5 canvas tag.
                                              </canvas>
                                         </div>
                                         
                                    </div>
                               </light-box>
                          </div>
                     </div>
                     <div style="padding-left: 10px;">
                          <span translate="birth_certificate.parental.text1_1"></span>
                          <a (click)="onBox1Open()" class="cursor" tabindex="0" (keypress)="keyPressBox1($event)"
                               alt-text="birth_certificate.parental.sample_link.alt_text">{{'birth_certificate.parental.sample_link.label' | translate}}</a>
                          <span>{{'birth_certificate.parental.text1_3' | translate: childNameParam }}</span>
                     </div>
                </div>
 
                <div>
                     <ul>
                          <li translate>{{'birth_certificate.parental.underage'}}</li>
                          <li translate>{{'birth_certificate.parental.passport'}}</li>
                          <li translate>{{'birth_certificate.parental.bc_info'}}</li>
                     </ul>
                </div>
 
                <div class="padding-checbox" id="orderOfBC">
                     <ng-checkbox [(ng-model)]="orderOfBC.hasBCWithParentInfo" (change)="addToOrderAmount('PBC')" id="orderOfBCcheckbox">
                          <div [hidden]="orderOfBC.hasBCWithParentInfo === 'Y'" translate>
                               {{'birth_certificate.parental.add_to_order'}}
                          </div>
                          <div [hidden]="!(orderOfBC.hasBCWithParentInfo === 'Y')">
                               <strong translate>{{'birth_certificate.parental.added_to_order'}}</strong>
                          </div>
                     </ng-checkbox>
                </div>
 
                <div class="padding-bottom-1em">
                     <ng-radio [(ng-model)]="orderOfBC.isReviewOtherTypeBC"
                               (change)="onReviewOtherTypeBCChange()"
                               [(ng-error)]="error_isBcOrCertBC"
                               [item-list]="items.yesNoList">
                               <strong translate = 'birth_certificate.parental.other_bc_review'></strong>
                     </ng-radio>
                </div>
           </div>
           
           <!--BC with Parental Info - End -->
 
           <!--Birth Certificate start-->
           <div [hidden]="!(orderOfBC.isReviewOtherTypeBC == 'Y')">
                <div id="birthCertificate" [hidden]="!(orderOfBC.isReviewOtherTypeBC == 'Y')">
                     <h2 translate>{{'birth_certificate.birth_certificate.header'}}</h2>
                     <h3 translate>{{'birth_certificate.birth_certificate.amount'}}</h3>
 
                     <div style="display: inline-flex;">
                          <div>
                               <div translate class="sr-only">{{'birth_certificate.birth_certificate.thumbnail.aoda_text'}}</div>
                               <div tabindex="0" (keypress)="keyPressBox2($event)">
                                    <div [hidden]="lang == 'fr'">
                                         <img src="refresh/assets/images/bc_simple_en.jpg" height="120" width="95" 
                                              (click)="onBox2Open()"  id="bcSimpleImg_en"
                                              class="cursor" 
                                              alt-text='birth_certificate.birth_certificate.thumbnail.alt_text'>
                                    </div>
                                    <div [hidden]="lang == 'en'">
                                         <img src="refresh/assets/images/bc_simple_fr.jpg" height="120" width="95" 
                                              (click)="onBox2Open()"  id="bcSimpleImg_fr"
                                              class="cursor" 
                                              alt-text='birth_certificate.birth_certificate.thumbnail.alt_text'>
                                    </div>
                                    <light-box input-class="white-box" #bcSimpleLightBox
                                               outer-class="bc_sample" outer-style="margin-top:2em">
                                         <header-x (close)="onBox2Close()"></header-x>
                                         <div>
                                              <span translate class="sr-only">{{ 'birth_certificate.birth_certificate.aoda_text' }}</span>
                                              <div (click)="onBox2Close()">
                                                   <canvas #bcSimpleCanvas style="cursor:pointer;" role="img">
                                                        Your browser does not support the HTML5 canvas tag.
                                                   </canvas>
                                              </div>
                                         </div>
                                    </light-box>
                               </div>
                          </div>
 
                          <div style="padding-left: 10px;">
                               <span translate="birth_certificate.birth_certificate.text1_1"></span>
                               <a (click)="onBox2Open()" class="cursor" tabindex="0" (keypress)="keyPressBox2($event)"
                                   alt-text="birth_certificate.birth_certificate.sample_link.alt_text">{{'birth_certificate.parental.sample_link.label' | translate}}</a>
                               <span>{{'birth_certificate.birth_certificate.text1_3' | translate: childNameParam }}</span>
 
                               <div>
                                    <ul>
                                         <li translate>{{'birth_certificate.birth_certificate.li_text1'}}</li>
                                         <li translate>{{'birth_certificate.birth_certificate.li_text2'}}</li>
                                    </ul>
                               </div>
                          </div>
                     
                     </div>
                     
                     <div class="padding-bottom-1em">
                          <ng-checkbox [(ng-model)]="orderOfBC.hasBirthCertificate" (change)="addToOrderAmount('BC')">
                               <div [hidden]="orderOfBC.hasBirthCertificate === 'Y'" translate>
                                    {{'birth_certificate.birth_certificate.add_to_order'}}
                               </div>
                               <div [hidden]="!(orderOfBC.hasBirthCertificate === 'Y')">
                                    <strong translate>{{'birth_certificate.birth_certificate.added_to_order'}}</strong>
                               </div>
                          </ng-checkbox>
                     </div>
                </div>
                <!--Birth Certificate - End -->
                
 
                <!--Certified Copy - start -->
                <div id="bc_certifiedCopy" class="padding-top-2em" [hidden]="!(orderOfBC.isReviewOtherTypeBC == 'Y')">
                     <h2 translate>{{'birth_certificate.certified_copy.header'}}</h2>
                     <h3 translate>{{'birth_certificate.certified_copy.amount'}}</h3>
 
                     <div>
                          <ul>
                               <li translate="birth_certificate.certified_copy.text1"></li>
                               <li>
                                    <span translate="birth_certificate.certified_copy.text2"></span>
                                    <a-link link-url="birth_certificate.certified_copy.faq_link.url" 
                                         alt-text="birth_certificate.certified_copy.faq_link.alt_text" 
                                         label='birth_certificate.certified_copy.faq_link.label'
                                         (click)=onFaqClick($event)>
                                    </a-link>
                                    <span translate="birth_certificate.certified_copy.text3"></span>
                               </li>
                               <li translate="birth_certificate.certified_copy.text4"></li>
                          </ul>
                     </div>
                     <div class="padding-checbox">
                     <ng-checkbox [(ng-model)]="orderOfBC.hasCertifiedCopyOfBR" (change)="addToOrderAmount('CBC')">
                          <div [hidden]="orderOfBC.hasCertifiedCopyOfBR === 'Y'" translate>
                               {{'birth_certificate.certified_copy.add_to_order'}}
                          </div>
                          <div [hidden]="!(orderOfBC.hasCertifiedCopyOfBR === 'Y')">
                               <strong translate>{{'birth_certificate.certified_copy.added_to_order'}}</strong>
                          </div>
                     </ng-checkbox>
                     </div>
                </div>
                <!--Certified Copy - End-->
           </div>
 
      </div>
 
      <div [hidden]="certifyingCount != 1 || isOtherCustody  || !isAddedToOrder()" class="padding-top-2em" id="birtCertificateSingleParent">
           <div>
                <strong translate="birth_certificate.single_parent"></strong>
           </div>
           <ng-checkbox [(ng-model)]="applicantChkBox" (change)="changeValue()"  [(ng-clear)]="error_whichParent" id="birtCertificateSingleParentCheckbox">
                 <span class="sr-only" translate="birth_certificate.single_parent"></span>
                    {{data.certifyingParents.values().next().value}}
           </ng-checkbox>
           <errors [error]="error_whichParent"></errors> 
 
           <accordion label="birth_certificate.applicant_accordion.header" outer-class="bottom-margin">
                <div *ngIf="!(data.aboutChild.isChildDeceased == 'Y')" translate="birth_certificate.applicant_accordion.text1"></div>
                <div *ngIf="data.aboutChild.isChildDeceased == 'Y'" translate="birth_certificate.applicant_accordion.text1_child_deceased"></div>
                <div translate="birth_certificate.applicant_accordion.text2" class="padding-top-1em"></div>
                <ul>
                     <li translate="birth_certificate.applicant_accordion.text3"></li>
                     <li translate="birth_certificate.applicant_accordion.text4"></li>
                     <li translate="birth_certificate.applicant_accordion.text5"></li>
                </ul>
           </accordion>  
      </div>
 
      <div id="twoOrMoreCertifying" class="padding-top-2em" 
           [hidden]="certifyingCount <= 1 || !isAddedToOrder()">
           <div>
                     <ng-radio  [item-list]="data.certifyingParents" id="twoOrMoreCertifyingRadio"
                                [(ng-model)]="orderOfBC.applicantIndex"  
                                [(ng-error)]="error_whichParent" vertical>
                                      <strong translate="birth_certificate.which_parent"></strong>
                     </ng-radio>
           </div>
           <div>
                <accordion label="birth_certificate.applicant_accordion.header" outer-class="bottom-margin">
                     <div *ngIf="!(data.aboutChild.isChildDeceased == 'Y')" translate="birth_certificate.applicant_accordion.text1"></div>
                     <div *ngIf="data.aboutChild.isChildDeceased == 'Y'" translate="birth_certificate.applicant_accordion.text1_child_deceased"></div>
                     <div translate="birth_certificate.applicant_accordion.text2" class="padding-top-1em"></div>
                     <ul>
                          <li translate="birth_certificate.applicant_accordion.text3"></li>
                          <li translate="birth_certificate.applicant_accordion.text4"></li>
                          <li translate="birth_certificate.applicant_accordion.text5"></li>
                     </ul>
                </accordion>
           </div>
      </div>
 
      <div [hidden]="!isOtherCustody || !isAddedToOrder()" class="padding-top-2em">
           <div>
                <div>
                     <strong translate="birth_certificate.no_parent_certifying"></strong>
                </div>
                <div class="padding-top-1em" id="isCustody">
                     <ng-checkbox [(ng-model)]="applicantChkBox" (change)="changeValue()" id="isCustodyCheckbox"
                                  [(ng-error)]="error_whichParent">
                          {{  getLegalCustodianName() }}
                     </ng-checkbox>
                </div>
           </div>
           <div>
                <accordion label="birth_certificate.applicant_accordion.header" outer-class="bottom-margin">
                     <div *ngIf="!(data.aboutChild.isChildDeceased == 'Y')" translate="birth_certificate.applicant_accordion.text1"></div>
                     <div *ngIf="data.aboutChild.isChildDeceased == 'Y'" translate="birth_certificate.applicant_accordion.text1_child_deceased"></div>
                     <div translate="birth_certificate.applicant_accordion.text2" class="padding-top-1em"></div>
                     <ul>
                          <li translate="birth_certificate.applicant_accordion.text3"></li>
                          <li translate="birth_certificate.applicant_accordion.text4"></li>
                          <li translate="birth_certificate.applicant_accordion.text5"></li>
                     </ul>
                </accordion>
           </div>
 
           <div id="organization">
                <ng-input [(ng-model)]="orderOfBC.organizationForOther" size="50" max="80" id="organizationInput"
                     alt-text='birth_certificate.organization.alt_text'
                     [(ng-error)]="error_invalidOrgName"> 
                     {{'birth_certificate.organization.label'}}
                </ng-input>  
           </div>
 
           <div>
                <information>
                     <h3 translate>{{'birth_certificate.additional_doc.header'}}</h3>
                     <div [innerHTML]="'birth_certificate.additional_doc.body' | translate"></div>
                </information>
           </div>
      </div>
 
 
      <!-- Consent -->
      <div id="consent" class="padding-top-2em padding-bottom-1em" [hidden]="!(orderOfBC.applicantIndex > -1 && isAddedToOrder()) ">
           <div>
                <strong translate="birth_certificate.consent.header"></strong>
                <ng-checkbox [(ng-model)]="orderOfBC.chk_BCConsent"
                             [(ng-error)]="error_invalidConsent"
                             id="birthCertificateCheckbox">
                     <div translate>
                          {{'birth_certificate.consent.text'}}
                     </div>
                </ng-checkbox>
           </div>
      </div>
 
      <div class="padding-top-2em">
           <errors [error]="error_invalidSubmit"></errors>  
      </div>
 
      <div class="btn-div">
           <div class="button-top">
                <button [ngClass]="data.subject.language=='fr'?'btn-next3':'btn-next2'" 
                        title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>
                     {{Button.Next}}
                </button>
           </div>
           <div class="button-bottom">
                <button [ngClass]="data.subject.language=='fr'?'btn-cancel3':'btn-cancelBC'"  
                        title="{{'birth_certificate.no_bc_button.alt_text'|translate}}" (click)="onNoBirthCertificateClick()" translate>
                     {{'birth_certificate.no_bc_button.label'}}
                </button>
           </div>
      </div>
 </div>
 
 <!--<light-box #faqLightBox input-class="white-box">
      <div style="padding-top:0.5em; padding-right:0.5em; padding-bottom:0">
            <header-x (close)="onFaqClose()" ></header-x>
      </div>
      <ng-container *ngComponentOutlet="FAQComponent"></ng-container>
 </light-box>-->